function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { userStore } from 'sdc-auth-user';
import { VisibleOnlyAuthenticated } from '../../helpers';
import './button.scss';

var TheLogoutButton = function TheLogoutButton(props) {
  return /*#__PURE__*/React.createElement("button", _extends({
    type: "button",
    onClick: userStore.logout
  }, props, {
    className: "btn-xs btn-warning logout-button"
  }), /*#__PURE__*/React.createElement("i", {
    className: "fa fa-power-off"
  }));
};

export var LogoutButton = VisibleOnlyAuthenticated(TheLogoutButton);